import React, { Component } from "react";
import { GET_ONE } from "react-admin";
import { showNotification } from "react-admin";
import Button from "@material-ui/core/Button";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import restClient from "../common/restClient";
import { withStyles } from "@material-ui/core";

const styles = {
    dialogIcon: { position: "relative", top: 5 },
    dialogIconDone: { position: "relative", top: 5, color: "green" }
};

class DownloadUtilityButton extends Component {
    state = {
        error: false,
        showDialog: false,
        isDownloading: false,
        url: this.props.url
    };
    handleClick = e => {
        e.preventDefault();
        this.setState({ showDialog: true, isDownloading: true });
        restClient(GET_ONE, "utilities", { id: this.props.id })
            .then(({ data }) => {
                this.setState({
                    url: data.url
                });
                if (data.url) {
                    window.open(data.url, "_self");
                } else {
                    this.setState({
                        error: true,
                        isDownloading: false
                    });
                    showNotification("file_not_found", "error");
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    url: "",
                    error: true,
                    isDownloading: false
                });
            })
            .finally(() => {
                // Dispatch an action letting react-admin know a API call has ended
                this.setState({
                    isDownloading: false
                });
            });
    };
    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    render() {
        // const { isSubmitting } = this.props;
        return (
            <span>
                <Button
                    color="primary"
                    href="#"
                    target="self"
                    disabled={!this.props.url}
                    onClick={this.handleClick}
                >
                    <DownloadIcon />
                    <span
                        style={{
                            paddingLeft: "0.5em",
                            position: "relative",
                            top: 3
                        }}
                    >
                        DOWNLOAD
                    </span>
                </Button>
            </span>
        );
    }
}

export default withStyles(styles)(DownloadUtilityButton);



// WEBPACK FOOTER //
// ./src/components/DownloadUtilityButton.js